import config from '../../../config'
import { 
    REGISTER_USERS_CONNECTED_MODULES_PROFILE,
    PROFILE_USER_UPDATE,
    LOADING_PROFILE_USER_UPDATE,
} from "../../../Constants/Profile/Profile"
import { notification } from 'antd'

const notificacionServidor = (type, mensaje) => {
    if(type === 'success'){
        notification['success']({
            message: 'Éxito',
            description: mensaje,
        })
    }else if(type === 'warning'){
        notification['warning']({
            message: 'Advertencia',
            description: mensaje,
        })
    }else if(type === 'error'){
        notification['error']({
            message: 'Error',
            description: mensaje,
        })
    }
}

export const RegisterUsersConnectedProfileReducer = ( data ) => async (dispatch, getState) => {
    dispatch({
        type: REGISTER_USERS_CONNECTED_MODULES_PROFILE,
        payload: data
    })
}

export const ChangeProfileUpdateUserReducer = (value, type) => async (dispatch, getState) => {
    const dataProfileUpdateUser = getState().profile.rex_profile_user_update
    dataProfileUpdateUser[type] = value

    dispatch({
        type: PROFILE_USER_UPDATE,
        payload: dataProfileUpdateUser
    })
}

export const ProfileUpdateUserReducer = () => async (dispatch, getState) => {
    let status = 200
    const { rex_profile_user_update } = getState().profile
    const { rex_data_user_logingrow } = getState().loginGrow

    dispatch({
        type: LOADING_PROFILE_USER_UPDATE,
        payload: true
    })

    await fetch(config.api+'users/update-user-profile',
        {
            mode:'cors',
            method: 'POST',
            headers: {
                'Accept' 	   : 'application/json',
                'Content-type' : 'application/json',
                'usutoken'      : localStorage.getItem('usutoken')
            },
            body: JSON.stringify({
                req_usuid: rex_data_user_logingrow.usuid,
                req_name: rex_profile_user_update.name ? rex_profile_user_update.name : rex_data_user_logingrow.perpersonas.pernombre,
                req_fullname: rex_profile_user_update.fullname ? rex_profile_user_update.fullname : rex_data_user_logingrow.perpersonas.perapellidos,
                req_usuario: rex_profile_user_update.usuario ? rex_profile_user_update.usuario : rex_data_user_logingrow.usuusuario,
                req_email: rex_profile_user_update.email ? rex_profile_user_update.email : rex_data_user_logingrow.usucorreo,
                req_gender: rex_profile_user_update.gender ? rex_profile_user_update.gender : rex_data_user_logingrow.gnrid,
                req_phone: rex_profile_user_update.phone ? rex_profile_user_update.phone : rex_data_user_logingrow.usutelefono,
                req_password: rex_profile_user_update.password,
            }),
        }
    )
    .then(res => {
        status = res.status
        return res.json()
    })
    .then(data => {
        if(data.response){
            notificacionServidor('success', data.message)

        }else{
            if(status == 400){
                notificacionServidor('warning', data.message)
            }else{
                notificacionServidor('error', data.message)
            }
        }
    }).catch((error)=> {
        console.log(error)
    })

    dispatch({
        type: LOADING_PROFILE_USER_UPDATE,
        payload: false
    })
}